const COMBINING_MARKS = /[̀-ͯ]/g;
const REGEXP_SPECIALS = /[.*+?^${}()|[\]\\]/g;

/**
 * Fold text to a comparable form: NFD-decompose, drop combining marks, lowercase.
 * `đ`/`Đ` are handled explicitly because they are single code points with no
 * decomposition — without this, "Đơn hàng" is unreachable by typing "don".
 */
export function normalize(value: string): string {
  return value
    .normalize('NFD')
    .replace(COMBINING_MARKS, '')
    .replace(/[đĐ]/g, 'd')
    .toLowerCase();
}

function escapeRegExp(value: string): string {
  return value.replace(REGEXP_SPECIALS, '\\$&');
}

/**
 * Rank a candidate against a query. Higher is better; `null` means no match.
 * An empty query scores 0 so callers can show a full, unranked list.
 */
export function scoreMatch(haystack: string, needle: string): number | null {
  const target = normalize(haystack);
  const query = normalize(needle).trim();

  if (!query) return 0;
  if (target.startsWith(query)) return 3;
  if (new RegExp(`\\b${escapeRegExp(query)}`).test(target)) return 2;
  if (target.includes(query)) return 1;
  return null;
}
